import Vue from 'vue'
import helpers from '~/mixins/helpers'
Vue.mixin(helpers);
